// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import { css, StyleSheet } from 'aphrodite/no-important'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { Component } from 'react'
import Flatpickr from 'react-flatpickr' // https://github.com/coderhaoxin/react-flatpickr#usage
import Select from 'react-select' // https://react-select.com/props
import { Dot } from '../../generic'

export default class TodoTimeSelector extends Component {
  static propTypes = {
    fields: PropTypes.object,
    setFormField: PropTypes.func.isRequired,
    noTitle: PropTypes.bool,
    testId: PropTypes.string
  }

  componentDidMount() {
    const { recurrence, startDate } = this.props.fields
    if (!recurrence) {
      this.props.setFormField({
        key: 'recurrence',
        value: 'once'
      })
    }

    if (!startDate) {
      this.props.setFormField({
        key: 'startDate',
        value: dayjs().toISOString()
      })
    }
  }

  handleTimeChange = (newDate) => {
    const { startDate } = this.props.fields
    const d = dayjs(newDate[0])
    this.props.setFormField({
      key: 'startDate',
      value: dayjs(startDate)
        .set('hour', d.get('hour'))
        .set('minute', d.get('minute'))
        .valueOf()
    })
  }

  handleDateChange = (newDate) => {
    const { startDate } = this.props.fields
    const d = dayjs(newDate[0])
    const startDateValue = dayjs(startDate)
    this.props.setFormField({
      key: 'startDate',
      value: d
        .set('hour', startDateValue.get('hour'))
        .set('minute', startDateValue.get('minute'))
        .valueOf()
    })
  }

  handleRecurrenceChange = ({ value }) => {
    this.props.setFormField({
      key: 'recurrence',
      value
    })
  }

  toggleRecurring = () => {
    const value = this.props.fields.recurrence === 'once' ? 'daily' : 'once'
    this.handleRecurrenceChange({ value })
  }

  renderReccuranceToggle = () => {
    const isRecurring = this.props.fields.recurrence !== 'once'
    const { testId } = this.props
    return (
      <div
        className={css(classes.toggleButton)}
        onClick={() => this.toggleRecurring()}
        data-testid={
          testId
            ? `${testId}-recurring-toggle`
            : 'todo-time-selector-recurring-toggle'
        }
      >
        <Dot
          label={
            isRecurring ? (
              <Icon name="CheckOutlined" />
            ) : (
              <Icon name="CloseOutlined" />
            )
          }
          active={isRecurring}
          color={colors.green}
        />{' '}
        Recurring?
      </div>
    )
  }

  renderTimePicker = () => {
    const { startDate } = this.props.fields
    const { testId } = this.props
    if (!startDate) return null

    const currentDate = dayjs(startDate).toDate()

    const date_options = {
      dateFormat: 'd M',
      defaultDate: currentDate
    }

    const time_options = {
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
      defaultDate: currentDate,
      time_24hr: true
    }

    return (
      <div
        className={css(classes.timeInputContainer)}
        data-testid={
          testId ? `${testId}-time-picker` : 'todo-time-selector-time-picker'
        }
      >
        <div
          data-testid={
            testId ? `${testId}-date-input` : 'todo-time-selector-date-input'
          }
        >
          <Flatpickr
            className={css(classes.input, classes.dateInput)}
            options={date_options}
            onChange={this.handleDateChange}
          />
        </div>
        <span
          style={{ margin: 20, fontSize: 16 }}
          data-testid={
            testId ? `${testId}-at-label` : 'todo-time-selector-at-label'
          }
        >
          at:
        </span>
        <div
          data-testid={
            testId ? `${testId}-time-input` : 'todo-time-selector-time-input'
          }
        >
          <Flatpickr
            className={css(classes.input, classes.timeInput)}
            options={time_options}
            onChange={this.handleTimeChange}
          />
        </div>
      </div>
    )
  }

  renderRecurringSelector = () => {
    const { testId } = this.props
    const recTypes = [
      { value: 'daily', label: 'Daily' },
      { value: 'weekly', label: 'Weekly' },
      { value: 'bi-weekly', label: 'Bi-Weekly' },
      { value: 'monthly', label: 'Monthly' }
    ]

    return (
      <div
        className={css(classes.reccuranceSelector)}
        data-testid={
          testId
            ? `${testId}-recurring-selector`
            : 'todo-time-selector-recurring-selector'
        }
      >
        <div
          style={{ paddingTop: 30, paddingBottom: 30, zIndex: 1000 }}
          data-testid={
            testId
              ? `${testId}-recurring-select-container`
              : 'todo-time-selector-recurring-select-container'
          }
        >
          <Select
            classNamePrefix="lmc-select"
            value={recTypes.filter(
              (type) => type.value === this.props.fields.recurrence
            )}
            options={recTypes}
            onChange={this.handleRecurrenceChange}
            inputProps={{
              'data-testid': testId
                ? `${testId}-recurring-select`
                : 'todo-time-selector-recurring-select'
            }}
          />
        </div>
      </div>
    )
  }

  render() {
    const {
      fields: { recurrence },
      noTitle,
      testId
    } = this.props
    return (
      <div
        className={css(classes.container)}
        data-testid={testId || 'todo-time-selector'}
      >
        {!noTitle && (
          <h2
            data-testid={
              testId ? `${testId}-title` : 'todo-time-selector-title'
            }
          >
            {TITLE}
          </h2>
        )}
        <div
          className={css(classes.formBody)}
          data-testid={
            testId ? `${testId}-form-body` : 'todo-time-selector-form-body'
          }
        >
          {this.renderTimePicker()}
          {this.renderReccuranceToggle()}
          {recurrence !== 'once' ? this.renderRecurringSelector() : null}
        </div>
      </div>
    )
  }
}

const TITLE = 'When is a good time to start?'

const classes = StyleSheet.create({
  container: {
    margin: 20,
    textAlign: 'center'
  },
  formBody: {
    width: '80%',
    margin: '40px auto 0'
  },
  timeInputContainer: {
    paddingBottom: 30
  },
  input: {
    textAlign: 'center',
    border: `1px solid ${colors.grey}`,
    borderRadius: 4,
    width: 100,
    letterSpacing: 1,
    padding: '8px 4px'
  },
  nextButton: {
    marginTop: 60,
    marginBottom: 40
  },
  dot: {
    height: 24,
    width: 24,
    fontSize: 11,
    paddingTop: 4,
    color: 'white',
    margin: '0 8px',
    backgroundColor: colors.grey,
    borderRadius: '50%',
    display: 'inline-block'
  },
  activeDot: {
    backgroundColor: colors.green
  },
  toggleButton: {
    ':hover': {
      opacity: 0.9,
      color: colors.darkgrey
    },
    fontWeight: 'bold',
    width: 170,
    margin: '0 auto',
    cursor: 'pointer',
    position: 'relative'
  },
  reccuranceSelector: {
    maxWidth: 420,
    margin: '0 auto',
    position: 'relative',
    top: -12
  },
  selectRecType: {
    width: 180,
    margin: '0 auto',
    ':nth-child(1n) .Select-clear-zone': {
      display: 'none'
    }
  }
})
